import { forwardRef } from 'react';
import { cn } from '../../helper/classNames';

const CardContent = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('p-6', className)}
    {...props}
  />
));
CardContent.displayName = 'CardContent';

export { CardContent };
